var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightModeIconVer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 27,
    rx: 13.5,
    fill: "#D1D1D1",
    stroke: "#D1D1D1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 14,
    r: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3372_74083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8357 11.164C16.1161 10.4444 15.1002 9.97884 13.9997 9.97884C12.8992 9.97884 11.8833 10.4233 11.1637 11.164C10.4441 11.8836 9.97852 12.8995 9.97852 14C9.97852 15.1005 10.4441 16.1164 11.1637 16.836C11.8833 17.5556 12.8992 18.0212 13.9997 18.0212C15.1002 18.0212 16.1161 17.5767 16.8357 16.836C17.5552 16.1164 18.0208 15.1005 18.0208 14C18.0208 12.8995 17.5764 11.8836 16.8357 11.164ZM16.0738 16.0741C15.5447 16.6032 14.8039 16.9206 13.9997 16.9206C13.1954 16.9206 12.4547 16.6032 11.9256 16.0741C11.3965 15.545 11.079 14.8042 11.079 14C11.079 13.1958 11.3965 12.455 11.9256 11.9259C12.4547 11.3968 13.1954 11.0794 13.9997 11.0794C14.8039 11.0794 15.5447 11.3968 16.0738 11.9259C16.6029 12.455 16.9203 13.1958 16.9203 14C16.9203 14.8042 16.6029 15.545 16.0738 16.0741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4494 13.4497H19.8198C19.5235 13.4497 19.2695 13.7037 19.2695 14C19.2695 14.2963 19.5235 14.5503 19.8198 14.5503H21.4494C21.7457 14.5503 21.9997 14.2963 21.9997 14C21.9997 13.7037 21.7457 13.4497 21.4494 13.4497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 19.2698C13.7042 19.2698 13.4502 19.5238 13.4502 19.8201V21.4497C13.4502 21.746 13.7042 22 14.0005 22C14.2968 22 14.5507 21.746 14.5507 21.4497V19.8201C14.5507 19.5238 14.2968 19.2698 14.0005 19.2698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6511 18.8889L18.487 17.7249C18.2966 17.5132 17.9368 17.5132 17.7251 17.7249C17.5135 17.9365 17.5135 18.2751 17.7251 18.4868L18.8892 19.6508C19.1008 19.8624 19.4394 19.8624 19.6511 19.6508C19.8627 19.4391 19.8627 19.1005 19.6511 18.8889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 6C13.7042 6 13.4502 6.25397 13.4502 6.55026V8.17989C13.4502 8.47619 13.7042 8.73016 14.0005 8.73016C14.2968 8.73016 14.5507 8.47619 14.5507 8.17989V6.55026C14.5507 6.25397 14.2968 6 14.0005 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6716 8.34921C19.4599 8.13757 19.1213 8.13757 18.9097 8.34921L17.7456 9.51323C17.534 9.72487 17.534 10.0635 17.7456 10.2751C17.9361 10.4868 18.2959 10.4868 18.5075 10.2751L19.6716 9.11111C19.8832 8.89947 19.8832 8.56085 19.6716 8.34921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17989 13.4497H6.55026C6.25397 13.4497 6 13.7037 6 14C6 14.2963 6.2328 14.5503 6.55026 14.5503H8.17989C8.47619 14.5503 8.73016 14.2963 8.73016 14C8.73016 13.7037 8.47619 13.4497 8.17989 13.4497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2536 17.7249C10.0631 17.5132 9.70334 17.5132 9.4917 17.7249L8.32768 18.8889C8.11604 19.1005 8.11604 19.4391 8.32768 19.6508C8.53932 19.8624 8.87794 19.8624 9.08958 19.6508L10.2536 18.4868C10.4652 18.2751 10.4652 17.9365 10.2536 17.7249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2536 9.51323L9.08958 8.34921C8.87794 8.13757 8.53932 8.13757 8.32768 8.34921C8.11604 8.56085 8.11604 8.89947 8.32768 9.11111L9.4917 10.2751C9.70334 10.4868 10.042 10.4868 10.2536 10.2751C10.4652 10.0635 10.4652 9.72487 10.2536 9.51323Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3372_74083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeIconVer2);
export default __webpack_public_path__ + "static/media/light-mode-icon-ver-2.1a3c4654c9b95285b5c6ac24da429606.svg";
export { ForwardRef as ReactComponent };